import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Fingerprint } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { bioAvailable, enableBio, disableBio } from "@/lib/biometric";

export const BiometricSettingsCard = () => {
  const [state, setState] = useState(null);
  const load = async () => {
    if (!(await bioAvailable())) { setState("unsupported"); return; }
    const r = await api.get("/auth/webauthn/status").catch(() => null);
    setState(r?.data?.enabled_on_device ? "on" : "off");
  };
  useEffect(() => { load(); }, []);
  const toggle = async () => {
    if (state === "on") { await disableBio(); toast.success("Biometria desativada neste aparelho"); }
    else { const r = await enableBio(); if (r.ok) toast.success("Biometria ativada neste aparelho"); else toast.error(r.error); }
    load();
  };
  if (!state) return null;
  return (
    <div className="bg-white rounded-2xl border border-slate-100 card-shadow p-6" data-testid="bio-settings-card">
      <h2 className="font-heading text-lg font-bold text-[#1e3a8a] mb-2 flex items-center gap-2">
        <Fingerprint className="w-5 h-5 text-[#7c3aed]" /> Entrar com biometria
      </h2>
      {state === "unsupported" ? (
        <p className="text-sm text-slate-500" data-testid="bio-unsupported">Este aparelho ou navegador não tem Face ID, digital ou Windows Hello disponível.</p>
      ) : (
        <>
          <p className="text-sm text-slate-600 mb-4" data-testid="bio-status">
            {state === "on" ? "Ativada neste aparelho. Em outro celular, entre com a senha e ative lá." : "Desativada neste aparelho."}
          </p>
          <Button onClick={toggle} variant={state === "on" ? "outline" : "default"} data-testid="bio-toggle"
            className={state === "on" ? "rounded-xl" : "rounded-xl bg-[#7c3aed] hover:bg-[#6d28d9] text-white"}>
            {state === "on" ? "Desativar neste aparelho" : "Ativar neste aparelho"}
          </Button>
        </>
      )}
    </div>
  );
};
